<template>
  <footer>
    <div class="nav !hidden xl:!flex">
      <RouterLink :to="{ path: '/', name: '' }">
        <div class="btn">Início</div>
      </RouterLink>
      <RouterLink :to="{ path: '/pagina/equipe', name: 'equipe' }">
        <div class="btn">Equipe</div>
      </RouterLink>
      <RouterLink :to="{ path: '/pagina/8', name: 'pagina', params: { id: 8 } }">
        <div class="btn">Historia</div>
      </RouterLink>
      <RouterLink :to="{ path: '/pagina/imager', name: 'imager' }">
        <div class="btn">Habblet Imager</div>
      </RouterLink>
      <RouterLink :to="{ path: '/pagina/valores', name: 'valores' }">
        <div class="btn">Valores</div>
      </RouterLink>
      <RouterLink :to="{ path: '/pagina/recordes', name: 'recordes' }">
        <div class="btn">Recordes</div>
      </RouterLink>
    </div>
    <div class="about">
      <div class="center">
        <div
          class="logo"
          :style="{ backgroundImage: 'url(' + store.initSite.logo_footer + ')' }"
        ></div>
        <div class="copy flex flex-col xl:flex-row gap-4 px-4">
          <span>Copyright © Todos os direitos reservados. Radio Habblet 2022 - {{ date }}.</span>
          <span
            >A RádioHabblet é um fã-site oficial do Habblet Hotel, não está afiliada com,
            patrocinada por, apoiada por, ou principalmente aprovada pela Rede Habblet. Nosso
            intuito é apenas dar informações e entretenimento a comunidade do hotel. Esta Fã Site
            pode utilizar as marcas registradas e outras propriedades intelectuais do Habblet, que
            estão permitidas sob a Política de Fã Sites Habblet.</span
          >
        </div>
        <p class="dev !font-light !text-xs">v{{ buildVersion }}</p>
        <div class="dev !mt-4 !block xl:!flex">
          Desenhado por&nbsp; DinhuLOL&nbsp;, desenvolvido por&nbsp;
          <a
            href="https://pauloferraco.com.br"
            target="_blank"
            title="Full-stack"
            rel="noopener noreferrer"
            >Paulo Ferraço</a
          >
          <img
            alt="Paulo Ferraço icon"
            src="https://ppanel.pauloferraco.com.br/imagem/uploads/upload-f78439cbf5f4692d5ade629c46fffb18.png"
            class="hidden xl:block mx-2"
          />
          e mantido por&nbsp;<a
            href="https://github.com/dalsochio"
            target="_blank"
            title="Full-stack"
            rel="noopener noreferrer"
            >Grons</a
          >
        </div>
      </div>
      <div class="backImg"></div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted } from 'vue'
import { useStore } from '@/stores/index.js'
import { formatBrYear } from '@/constants/locale.js'

const buildVersion = import.meta.env.VITE_BUILD_VERSION ?? 'DEV'
const store = useStore()
defineProps(['logof'])

const date = formatBrYear()

function checkBuildVersion() {
  if (typeof localStorage === 'undefined') return
  const storedVersion = localStorage.getItem('buildVersion')

  if (storedVersion && storedVersion !== buildVersion) {
    localStorage.setItem('buildVersion', buildVersion)
    location.reload()
  } else if (!storedVersion) {
    localStorage.setItem('buildVersion', buildVersion)
  }
}

onMounted(checkBuildVersion)
</script>

<style scoped>
/*noinspection ALL*/
footer {
  position: relative;
  float: left;
  width: 100%;
  height: auto;
  background-color: var(--color2);
  margin-top: 30px;
  @apply pb-24 xl:pb-14;
}

/*noinspection CssUnresolvedCustomProperty*/
footer .nav {
  position: relative;
  width: 100%;
  height: 60px;
  background-color: var(--color2);
  display: flex;
  justify-content: center;
}

footer .nav .btn {
  float: left;
  width: auto;
  height: 100%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 20px;
}

footer .about {
  position: relative;
  height: 350px;
}

footer .about .logo {
  float: left;
  width: 140px;
  height: 100px;
  margin: 20px 0 0 50%;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-position: center;
}

footer .about .copy,
footer .about .dev {
  float: left;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

footer .about .dev {
  font-weight: 600;
}

footer .about .dev img {
  width: 15px;
  height: 15px;
}

footer .backImg {
  position: absolute;
  right: 0;
  top: 0;
  width: 657px;
  height: 300px;
  background-image: url('../assets/headerBack.png');
  background-repeat: no-repeat;
}
</style>
